import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UsersService } from 'gung-standard';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CultUsersService extends UsersService {
  getDefaultUserRoles() {
    return of([
      { selected: false, id: 'ACTUATOR' },
      { selected: false, id: 'ADMIN' },
      { selected: false, id: 'SALES' },
      { selected: false, id: 'USER' },
      { selected: false, id: 'RETUR_NOPRICE' },
      { selected: false, id: 'SHOW_ONLY_RETURNS'}
    ]);
  }
}
